import type { PromotionTab, TaskState } from '../components/IcePromotion/types';

const liveTaskStates: readonly TaskState[] = ['AVAILABLE', 'INPROGRESS'] as const;
const completedTypeState: Readonly<TaskState> = 'COMPLETED' as const;

const getPromotionTabForTaskState = (taskState: TaskState): PromotionTab | null => {
  if (taskState === completedTypeState) return 'COMPLETED';
  if (liveTaskStates.includes(taskState)) return 'LIVE';
  return null;
};

export default getPromotionTabForTaskState;
